<template>
  <div id="counter" class="container">
    <div class="text-muted set">{{ game.gameInfo.matchName }}</div>
    <div v-if="(info.p1 + info.p2) > 0" class="title-font set mt-1">
      <span id="player1-set">{{ info.s1 }}</span> - <span id="player2-set">{{ info.s2 }}</span>
    </div>
    <div v-else class="title-font pot mt-1">
      <span id="player1-set">{{ info.s1 }}</span> - <span id="player2-set">{{ info.s2 }}</span>
    </div>
    <div>
      <span id="player1-name" class="name">{{ game.gameInfo.player1Name }}</span>
      <span v-if="(info.p1 + info.p2) > 0" class="title-font pot m-3">
        <span id="player1-pot">{{ info.p1 }}</span> - <span id="player2-pot">{{ info.p2 }}</span>
      </span>
      <span v-else class="title-font set m-4">
        <span id="player1-pot">{{ info.p1 }}</span> - <span id="player2-pot">{{ info.p2 }}</span>
      </span>
      <span id="player2-name" class="name">{{ game.gameInfo.player2Name }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'counter',
  props: ['info'],
  computed: {
    ...mapGetters([
      'game',
    ]),
  },
};
</script>

<style scoped>
#counter{
  text-align: center;
}

.set{
  font-size: 1.5em;
}

.pot{
  font-size: 3em;
}

#player1-name{
  border-bottom: solid 0.5em #66a2cc;
}

#player2-name{
 border-bottom: solid 0.5em #04B4AE;
}

@media screen and (min-width:765px){
  .name{
    font-size: 1.5em;
  }
  .set{
    font-size: 2em;
  }
  .pot{
    font-size: 4em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/Counter.vue